<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <div class="close-icon" @click="$emit('closemodal')">x</div>
            <slot name="header"></slot>
          </div>

          <div class="modal-body">
            <slot name="body">default body</slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "modal",
  props: {
    color: { type: String, default: "#0091DA" }
  }
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 100%;
  max-width: 656px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  box-sizing: border-box;
  overflow: auto;
}

@media screen and (max-width: 674px) {
  .modal-container {
    height: 100vh;
    padding: 20px;
  }
}

.modal-header {
  position: relative;
  display: block;
}

.close-icon {
  position: absolute;
  right: -10px;
  top: 0px;
  cursor: pointer;
  font-weight: bold;
  display: inline-block;
  width: 20px;
  text-align: center;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  color: white;
  min-height: 44px;
  min-width: 149px;
  border-radius: 22px;
  background-color: #0091da;
  border: none;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
  margin: auto;
}

.modal-footer {
  text-align: center;
  padding: 15px 0px;
}

@media screen and (max-width: 768px) {
  .modal-footer {
    text-align: right;
  }
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
